import React from 'react';
import ClientInventory from 'src/pages/client/inventory/index';

const Page = function () {
  return <ClientInventory />;
};

export default Page;
